module.exports = __webpack_public_path__ + "static/media/list_black.cdd53228.svg";